import { ChangeEvent, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import CustomTextInput from "../../shared/CustomInput/CustomTextInput";
import CustomButton from "../../shared/CustomButton/CustomButton";
import LeopartOnDarkvector from "../../assets/icons/LeopartOnDarkvector";
import { useToastAlert } from "../../hooks/useToastAlert/useToastAlert";
import { RoutesReact } from "../../constants/routes";

const AUTH_BASE = (() => {
  const BASE_URL = process.env.REACT_APP_BASE_URL || '';
  return BASE_URL.endsWith('/api')
    ? BASE_URL.replace(/\/api$/, '') + '/api/auth'
    : BASE_URL + '/auth';
})();

export const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const toastAlert = useToastAlert();

  const handleSubmit = async () => {
    if (!email) {
      toastAlert({ duration: 4000, type: "error", message: "Inserisci la tua email" });
      return;
    }
    setIsLoading(true);
    try {
      await axios.post(`${AUTH_BASE}/forgot-password`, { email });
      setSubmitted(true);
    } catch {
      toastAlert({
        duration: 4000,
        type: "error",
        message: "Errore durante l'invio. Riprova.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container__login">
      <div className="container__header">
        <div className="header text-medium-14">
          <div className="d-flex align-items-center">
            <LeopartOnDarkvector w={"44px"} h={"44px"} />
            <span className="title">Leopart</span>
          </div>
        </div>

        <div id="container-form" className="container__form">
          {submitted ? (
            <>
              <h1 className="title text-bold-32">Email inviata</h1>
              <p className="text-regular-16 mt-3">
                Se l'email esiste nel sistema, riceverai un link per reimpostare la password.
              </p>
              <Link to={RoutesReact.DIRECTOR_LOGIN}>
                <span className="text-bold-14 cursor-pointer">Torna al login</span>
              </Link>
            </>
          ) : (
            <>
              <h1 className="title text-bold-32">Password dimenticata</h1>
              <span className="description text-regular-16">
                Inserisci la tua email per ricevere il link di reset.
              </span>
              <CustomTextInput
                label="Email"
                value={email}
                className="email__input"
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                  setEmail(event.target.value)
                }
              />
              <CustomButton
                fullWidth
                className="submit__button"
                isLoading={isLoading}
                onClick={handleSubmit}
              >
                Invia link
              </CustomButton>
              <p>
                <Link to={RoutesReact.DIRECTOR_LOGIN}>
                  <span className="text-bold-14 cursor-pointer">Torna al login</span>
                </Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
